module.exports = __webpack_public_path__ + "assets/media/day13.badc7dd1.mp3";